
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">
              Ordenes de compras pendientes por subcategoría y proveedor
            </h5>
            <div class="row">
              <div class="col-md-12">
                <TiendaSelectComponent :current="current" />
              </div>
              <div class="col-md-12">
                <ProveedoresSelectComponent :current="current" />
              </div>
              <div class="col-md-12">
                <SubCategoriaSelectComponent :current="current" />
              </div>
            </div>
            <div class="form-buttons-w">
              <div>
                <button
                  class="btn btn-md btn-success btn-block"
                  @click="refresh()"
                  v-if="current && current.tienda"
                >
                  Buscar
                </button>
              </div>
              <br />
              <div>
                <button
                  class="btn btn-md btn-dark btn-block"
                  @click="cleanFilters()"
                >
                  Limpiar
                </button>
              </div>
              <br />
            </div>
            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <br />
              <button
                type="button"
                v-if="datos"
                @click="imprimir(current)"
                class="btn btn-secondary btn-sm btn-block"
              >
                <span>Descargar en PDF</span>
              </button>
              <br />
              <br />
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Tienda</th>
                      <th>Sku</th>
                      <th>Descripcion</th>
                      <th>Fecha</th>
                      <th class="text-right">Categoria</th>
                      <th class="text-right">SubCategoria</th>
                      <th class="text-right">Solicitada</th>
                      <th class="text-center">Ingresada</th>
                      <th class="text-center">Pendiente</th>
                      <th class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td>{{ item.tienda }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'inventario-reportes-kardex',
                            params: {
                              sku: item.sku,
                              tienda: item.tienda_id,
                            },
                          }"
                          class="font-weight-bold"
                          style="color: ForestGreen"
                        >
                          <i class="fas fa-external-link-alt"></i>&nbsp;
                          <span>{{ item.sku }}</span>
                        </router-link>
                      </td>
                      <td>{{ item.producto }}</td>
                      <td>
                        {{ item.fecha_creacion | moment("DD/MM/YYYY HH:MM") }}
                      </td>
                      <td class="text-right">{{ item.codigo_subcat }}</td>
                      <td class="text-right">{{ item.nombre_subcat }}</td>
                      <td
                        style="color: Blue"
                        class="text-right font-weight-bold"
                      >
                        {{ item.solicitada }}
                      </td>
                      <td class="text-center">
                        {{ item.ingresada }}
                      </td>
                      <td class="text-center">
                        {{ item.pendiente }}
                      </td>
                      <td>
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'compras-ordencompra-editar',
                            params: { id: item.e_id },
                          }"
                          class="btn btn-success btn-sm"
                          ><i class="fas fa-eye"></i
                        ></router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoSelectComponent,
    SubCategoriaSelectComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      current: {},
      params: {},
      datos: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    cleanFilters() {
      let self = this;
      self.current.subcategoria = null;
      self.current.proveedor = null;
      self.current.tienda = null;
      self.delete();
    },
    delete() {
      delete self.current.subcategoria;
      delete self.current.proveedor;
      delete self.current.tienda;
    },
    imprimir() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let props = `&tienda=${self.params.tienda}`;
      self.params = Object.assign({}, self.current);
      if (self.params.subcategoria) {
        props = props + `&subcategoria=${self.params.subcategoria.codigo}`;
      }
      if (self.params.proveedor) {
        props = props + `&proveedor=${self.params.proveedor.codigo}`;
      }
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=compras/ordenes_compra/oc_pendiente_x_poveedor_x_categoria.jrxml` +
          props
      );
    },
    refresh() {
      let self = this;
      self.params = Object.assign({}, self.current);
      if (self.params.subcategoria) {
        self.params.subcategoria = self.params.subcategoria.codigo;
      }
      if (self.params.proveedor) {
        self.params.proveedor = self.params.proveedor.codigo;
      }
      console.log(self.params);
      DynamicService.getActionList(
        "compras",
        "orden_compra_e",
        "oc_pendientes_x_proveedor_subcategoria",
        self.params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
